import truncate from 'components/shared/mixins/truncate'
import { mapGetters } from 'vuex'
import routeHelper from 'components/shared/mixins/routeHelper'
import moment from 'moment'
import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'

export default {
    mixins: [truncate, routeHelper, convertMinutesToHours],
    props: {
        course: Object,
        modalIsOpen: Boolean,
        index: {
            type: Number,
            default: null
        },
        editable: Boolean,
        isBeingEdited: {
            type: Boolean,
            default: false
        },
        isWatchListItem: {
            type: Boolean,
            default: false
        },
        isUnCompletedView: {
            type: Boolean,
            default: false
        },
        isCompletedView: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            descLength: 250
        }
    },
    computed: {
        ...mapGetters({
            isLoggedIn: 'isLoggedIn',
            allDigitalClassRoomEvents: 'Courses/getAllDigitalClassRoomEvents',
            digitalClassRoomTrainingByCourseId: 'Courses/getDigitalClassRoomEventsWithCourseId',
            isDigitalClassRoomTraining: 'Courses/isDigitalClassRoomTraining',
            mapCourseToRibbon: 'Courses/mapCourseToRibbon',
            signedUpEvents: 'Courses/getSignedUpEventsForUser'
        }),
        showAddToFavourite () {
            return this.isLoggedIn && !this.isWatchListItem
        },
        progress () {
            return null
        },
        userHasNoAccess () {
            return this.course.demo && this.isLoggedIn
        },
        isExpired () {
            if (this.course.id < 0 || !this.course.id) {
                return true
            }
            if (this.mapCourseToRibbon(this.course)) {
                return this.mapCourseToRibbon(this.course).name === this.$t('Ribbon.unavailable')
            }
            return false
        },
        isCompletedCourseExpired () {
            return this.course.course.isExpired
        },
        isWatchListItemInEditMode () {
            return this.isBeingEdited && this.isWatchListItem
        },
        isSignedUpToDigitalClassRoomEvent () {
            if (!this.signedUpEvents) {
                return false
            }
            return this.signedUpEvents.filter(event => this.course.id === event.training?.course.id && event.subscriptionStatus === 'ok' &&
                moment(event.training.sessions[0].endDateAndTime).unix() > moment().unix()).length > 0
        },
        getSignedUpToDigitalClassroomLabel () {
            const signUpeRequired = this.useRedTag ? this.$t('DigitalClassrooms.remember_to_sign_up') : this.$t('DigitalClassrooms.sign_up_required')
            return this.isSignedUpToDigitalClassRoomEvent ? this.$t('DigitalClassrooms.signed_up') : signUpeRequired
        },
        truncateDescription () {
            if (this.course.description.length < this.descLength) {
                return this.course.description
            } else {
                return this.course.description.substring(0, this.descLength) + '...'
            }
        }
    }
}
